import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 10a6 6 0 1 1 12 0v10","key":"svg-0"}],["path",{"d":"M12 16h8","key":"svg-1"}],["path",{"d":"M12 12h8","key":"svg-2"}]]

const IconCurrencyDram = createReactComponent('outline', 'currency-dram', 'CurrencyDram', __iconNode);

export default IconCurrencyDram;